import { Components, Theme } from '@mui/material'

const typographyComponent: Components<Theme>['MuiTypography'] = {
  defaultProps: {
    // This maps Typography variants to the HTML element that should be used.
    variantMapping: {
      h1: 'h1',
      h2: 'h2',
      h3: 'h3',
      h4: 'h4',
      h5: 'h5',
      h6: 'h6',

      // Subtitle
      subtitle1: 'h6',
      subtitle2: 'h6',
      subtitle3: 'h6',

      // Body
      bodyExtraLarge: 'p',
      bodyLarge: 'p',
      bodyMedium: 'p',
      bodySmall: 'p',
      bodyExtraSmall: 'p',

      // Button
      buttonLarge: 'span',
      buttonMedium: 'span',
      buttonSmall: 'span',

      // Caption
      captionLarge: 'span',
      captionMedium: 'span',
      captionSmall: 'span',

      // Overline
      overlineExtraLarge: 'span',
      overlineLarge: 'span',
      overlineMedium: 'span',
      overlineSmall: 'span',
    },
  },
}

export { typographyComponent }
